import TablePagination from './table-pagination';

const mobileFilters = document.querySelector('.filter-bar__mobile');
const blockSearch = document.querySelector('.filter-bar__block--search');
const blockFilters = document.querySelector('.filter-bar__block--filters');
const blockSearchControl = document.querySelector('.filter-bar__control--search');
const blockFiltersControl = document.querySelector('.filter-bar__control--filters');

const scrollTableToTop = function () {
  if (window.innerWidth > 768) {
    const tableTop = document.querySelector('.table-body');
    if (tableTop) {
      const offset = 300;
      const rect = tableTop.getBoundingClientRect();
      const targetY = rect.top + window.pageYOffset - offset;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    }
  }
};

blockSearchControl.addEventListener('click', () => {
  mobileFilters.classList.add('active');
  blockSearch.classList.add('open');
  blockFilters.classList.remove('open');
});

blockFiltersControl.addEventListener('click', () => {
  mobileFilters.classList.add('active');
  blockFilters.classList.add('open');
  blockSearch.classList.remove('open');
  document.body.style.overflow = 'hidden';
});

window.addEventListener('resize', () => {
  if (window.innerWidth > 768) {
    document?.querySelectorAll('details.table__brands-details')?.forEach((el) => {
      el?.setAttribute('open', 'true');
    });
  }
});

const tableWrapper = document.querySelector('.table-body');
const tableEmpty = document.querySelector('.table__empty');
const originalOrder = Array.from(document.querySelectorAll('.table-group'));

const filterState = {
  brand: [],
  destination: [],
  search: '',
  discount: [],
};

window.filterState = filterState;

function isWithinFilter(points, filter) {
  if (filter.length === 0) {
    return true;
  }
  const [min, max] = filter.map(Number);
  return Boolean(points.map(Number).some((point) => point >= min && point <= max));
}

function applyFilters() {
  if (tableWrapper) {
    tableWrapper.innerHTML = '';
  }
  if (tableEmpty) {
    tableEmpty.classList.add('hidden');
  }

  document.body.style.overflow = '';

  const matchesFilter = (group) => {
    const brand = group.getAttribute('data-filter-brand');
    const locations = group.getAttribute('data-filter-location')?.split(',') || [];
    const searchText = group.textContent.toLowerCase();

    const matchBrand = !filterState.brand.length || filterState.brand.includes(brand);

    const matchLocation = !filterState.destination.length
      || filterState.destination.some((loc) => locations.includes(loc));

    const searchTerm = filterState.search.toLowerCase();
    const matchSearch = !filterState.search || searchText.includes(searchTerm);

    return matchBrand && matchLocation && matchSearch;
  };

  // eslint-disable-next-line max-len
  if (!filterState.brand.length && !filterState.destination.length && !filterState.search && !filterState.discount.length) {
    originalOrder.forEach((grouped) => {
      const group = grouped;
      tableWrapper.appendChild(group);
      group.style.display = '';
      group.querySelectorAll('.js-table-row').forEach((item) => {
        const row = item;
        row.style.display = '';
      });
    });
    return;
  }

  const filtered = originalOrder.filter(matchesFilter);

  if (filtered.length === 0) {
    if (tableEmpty) {
      tableEmpty.classList.remove('hidden');
    }
    return;
  }

  const { discount } = filterState;

  let filter = [];

  if (typeof discount === 'string' && discount.length > 0) {
    filter = discount.split(',');
  } else {
    filter = discount;
  }

  filtered.forEach((grouped) => {
    const group = grouped;
    const rows = group.querySelectorAll('.js-table-row[data-points]');
    let hasVisibleRows = true;

    if (rows.length > 0) {
      hasVisibleRows = false;
    }

    rows.forEach((item) => {
      const row = item;
      const points = row.dataset.points.split(',');
      const show = isWithinFilter(points, filter);

      row.style.display = 'none';

      if (show === true) {
        row.style.display = '';
        hasVisibleRows = true;
      }
    });

    if (hasVisibleRows === true) {
      group.style.display = '';
      tableWrapper.appendChild(group);
    }
  });
}

window.applyFilters = applyFilters;

function hasActiveFilters() {
  return Boolean(
    filterState.brand.length
    || filterState.destination.length
    || filterState.search
    || filterState.discount.length,
  );
}

function clearAllFilters() {
  filterState.brand = [];
  filterState.destination = [];
  filterState.search = '';
  filterState.discount = [];

  const allSelects = document.querySelectorAll('.c-custom-select');
  allSelects.forEach((select) => {
    const listItems = select.querySelectorAll('.c-custom-select__options li');
    const hiddenInput = select.querySelector('input[type="hidden"]');
    const filterNameField = select.querySelector('.c-custom-select__filter');

    listItems.forEach((item) => {
      item.classList.remove('active');
      item.classList.remove('grouped');
    });

    if (hiddenInput) {
      hiddenInput.value = '';
    }

    if (filterNameField) {
      const baseText = filterNameField.textContent.replace(/\s*\(\d+\)$/, '').replace(/\s*\|\s*\d+$/, '');
      filterNameField.textContent = baseText;
    }
  });

  const searchInputs = document.querySelectorAll('.filter-bar__search input.search');
  searchInputs.forEach((input) => {
    // eslint-disable-next-line no-param-reassign
    input.value = '';
  });

  applyFilters();
}

function clearFiltersOnly() {
  filterState.brand = [];
  filterState.destination = [];
  filterState.discount = [];

  const allSelects = document.querySelectorAll('.c-custom-select');
  allSelects.forEach((select) => {
    const listItems = select.querySelectorAll('.c-custom-select__options li');
    const hiddenInput = select.querySelector('input[type="hidden"]');
    const filterNameField = select.querySelector('.c-custom-select__filter');

    listItems.forEach((item) => {
      item.classList.remove('active');
      item.classList.remove('grouped');
    });

    if (hiddenInput && hiddenInput.name !== 'search') {
      hiddenInput.value = '';
    }

    if (filterNameField) {
      const baseText = filterNameField.textContent.replace(/\s*\(\d+\)$/, '').replace(/\s*\|\s*\d+$/, '');
      filterNameField.textContent = baseText;
    }
  });

  applyFilters();
}

function clearSearchOnly() {
  const searchInputs = document.querySelectorAll('.filter-bar__search input.search');
  searchInputs.forEach((input) => {
    // eslint-disable-next-line no-param-reassign
    input.value = '';
  });
  filterState.search = '';
  applyFilters();
}

// Removed setupFilter functions - now everything is handled in c-custom-select.js

// setupDiscountFilter removed - now handled in c-custom-select.js

function setupSearch() {
  const desktopSearchInputs = document.querySelectorAll('.filter-bar__search--desktop input.search');
  const mobileSearchInputs = document.querySelectorAll('.filter-bar__search--mobile input.search');

  desktopSearchInputs.forEach((input) => {
    input.addEventListener('input', (e) => {
      filterState.search = e.target.value;
      applyFilters();
    });
  });

  mobileSearchInputs.forEach((input) => {
    input.addEventListener('input', (e) => {
      filterState.search = e.target.value;
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        applyFilters();
        mobileFilters.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });
}

setupSearch();

document.addEventListener('click', (e) => {
  if (e.target.classList.contains('filter-bar__clear-search')) {
    const wrapper = e.target.closest('.filter-bar__search');
    const input = wrapper?.querySelector('input');
    if (input) input.value = '';
    filterState.search = '';
    if (window.applyFilters) {
      window.applyFilters();
    }
  }

  if (e.target.closest('.filter-bar__close') && mobileFilters) {
    mobileFilters.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (e.target.classList.contains('filter-bar__apply')) {
    const mobileDestinationInput = document.querySelector('.filter-bar__mobile [name="destination"]');
    const mobileBrandInput = document.querySelector('.filter-bar__mobile [name="brand"]');
    const mobileSearchInput = document.querySelector('.filter-bar__mobile input.search');
    const mobileDiscountInput = document.querySelector('.filter-bar__mobile [name="discount"]');

    // Update filter state from mobile selects
    if (mobileDestinationInput) {
      const value = mobileDestinationInput.value || '';
      filterState.destination = value ? value.split(',').map((v) => v.trim()).filter((v) => v) : [];
    }

    if (mobileBrandInput) {
      const value = mobileBrandInput.value || '';
      filterState.brand = value ? value.split(',').map((v) => v.trim()).filter((v) => v) : [];
    }

    if (mobileSearchInput) {
      filterState.search = mobileSearchInput.value || '';
    }

    if (mobileDiscountInput) {
      const valueDiscount = mobileDiscountInput.value || '';
      filterState.discount = valueDiscount ? valueDiscount.split(',').map((v) => v.trim()).filter((v) => v) : [];
    }

    if (window.applyFilters) {
      window.applyFilters();
    }

    if (mobileFilters) {
      mobileFilters.classList.remove('active');
    }
  }

  if (e.target.classList.contains('filter-bar__clear')) {
    const inSearchBlock = e.target.closest('.filter-bar__block--search');
    const inFiltersBlock = e.target.closest('.filter-bar__block--filters');

    if (inSearchBlock) {
      clearSearchOnly();
      return;
    }

    if (inFiltersBlock) {
      clearFiltersOnly();
      return;
    }

    clearAllFilters();
  }
});

// Initialize pagination when page loads
document.addEventListener('DOMContentLoaded', () => {
  const tablePagination = document.querySelector('.table__pagination');

  if (tablePagination) {
    window.tablePagination = new TablePagination();
  }
});

// Integrate with existing filter system
const originalApplyFilters = window.applyFilters;
window.applyFilters = function () {
  if (originalApplyFilters) {
    originalApplyFilters();
  }

  setTimeout(() => {
    if (window.tablePagination && typeof window.tablePagination.refresh === 'function') {
      if (hasActiveFilters()) {
        window.tablePagination.refresh();
      }
      scrollTableToTop();
      return;
    }
    scrollTableToTop();
  }, 0);
};
